import { motion, useReducedMotion } from "framer-motion";

// Pétalas/corações a cair, suaves e lentos. Decorativo — escondido de leitores
// de ecrã e desativado para quem prefere menos movimento.
const PETALAS = [
  { esquerda: "8%", atraso: 0, duracao: 11, tamanho: 18, emoji: "🌸" },
  { esquerda: "20%", atraso: 2.5, duracao: 13, tamanho: 14, emoji: "💛" },
  { esquerda: "34%", atraso: 1, duracao: 12, tamanho: 16, emoji: "🌸" },
  { esquerda: "48%", atraso: 4, duracao: 14, tamanho: 20, emoji: "✦" },
  { esquerda: "62%", atraso: 0.5, duracao: 12.5, tamanho: 15, emoji: "💛" },
  { esquerda: "76%", atraso: 3, duracao: 11.5, tamanho: 18, emoji: "🌸" },
  { esquerda: "90%", atraso: 1.8, duracao: 13.5, tamanho: 14, emoji: "✦" },
];

export function Petalas() {
  const reduzir = useReducedMotion();
  if (reduzir) return null;

  return (
    <div className="pointer-events-none fixed inset-0 -z-0 overflow-hidden" aria-hidden>
      {PETALAS.map((p, i) => (
        <motion.span
          key={i}
          initial={{ y: "-10vh", opacity: 0, rotate: 0 }}
          animate={{ y: "110vh", opacity: [0, 0.9, 0.9, 0], rotate: 360 }}
          transition={{
            duration: p.duracao,
            delay: p.atraso,
            repeat: Infinity,
            ease: "linear",
          }}
          style={{ left: p.esquerda, fontSize: p.tamanho }}
          className="absolute top-0 select-none text-ouro/70"
        >
          {p.emoji}
        </motion.span>
      ))}
    </div>
  );
}
